import React, { useState, memo } from 'react';
import { ApiRequestError } from '@/common/app/utils/errorsUtils';
import { useRouter } from 'next/router';
import { Button, Spinner } from '@/common/ui';
import * as S from './AccessForm.styles';
import { CommonMeta } from '@/common/ui/meta/CommonMeta';
import Layout from '@/shared/Layout/ui/Layout';
import { fetchByAccessKey } from '@/entities/Checkout/service/fetchByAccessKey';

const AccessFormContainer = () => {
    const router = useRouter();
    const [value, changeValue] = useState('');
    const [isError, setIsError] = useState(false);
    const [isLoading, changeIsLoading] = useState(false);

    const onSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        try {
            e.preventDefault();
            changeIsLoading(true);

            const response = await fetchByAccessKey(value).catch((err) => {
                if (err instanceof ApiRequestError) {
                    setIsError(true);
                    console.log(err);
                    return null;
                }
                throw err;
            });

            if (!response || typeof response !== 'object') {
                throw new Error('Something is wrong... Please retype your access key');
            }

            if (!response.success || typeof response.data !== 'object' || !response.data.id) {
                setIsError(true);
                throw new Error(
                    Array.isArray(response.errors) && response.errors.length > 0
                        ? response.errors.join(', ')
                        : 'Incorrect access key'
                );
            }

            router.push({
                pathname: '/order/access',
                query: { key: response.data.accesskey },
            });
        } catch (err) {
            changeIsLoading(false);
            console.log(err);
        }
    };

    return (
        <Layout noFooter>
            <CommonMeta title="Access - TripShock!" description="" imageSrc="" slug="" />
            <S.Wrapper>
                <S.InfoContainer>
                    <S.Form onSubmit={onSubmit}>
                        <S.FormGroup>
                            <S.Label htmlFor="access_key">Access key</S.Label>
                            <S.Input
                                placeholder="Enter access key"
                                id="access_key"
                                onChange={(e) => changeValue(e.target.value)}
                            />
                            {isError && !isLoading && (
                                <S.ErrorText>
                                    <S.IconWrapper>
                                        <S.ErrorIcon />
                                    </S.IconWrapper>
                                    Wrong access key!
                                </S.ErrorText>
                            )}
                        </S.FormGroup>
                        <Button
                            onClick={() => null}
                            disabled={value.length <= 0 || isLoading}
                            variant="primary"
                        >
                            {isLoading ? <Spinner isLoading /> : <span>Submit</span>}
                        </Button>
                    </S.Form>
                </S.InfoContainer>
            </S.Wrapper>
        </Layout>
    );
};

const AccessForm = memo(AccessFormContainer);

export { AccessForm };
